// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__19WaN"};